import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import VideoGraphyPage from '@/components/VideoGraphyPage.vue';
import VideoEditingPage from '@/components/VideoEditingPage.vue';
import GraphicDesigningPage from '@/components/GraphicDesigningPage.vue';
import PhotoGraphyPage from '@/components/PhotoGraphyPage.vue';
// import ThreeDmodelingPage from '@/components/ThreeDmodelingPage.vue';
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path:'/videography',
    name:"VideoGraphy",
    component:VideoGraphyPage
  },
  {
    path:'/videoediting',
    name:"VideoEditing",
    component:VideoEditingPage
  },
  {
    path:'/graphicdesigning',
    name:"GraphicDesigning",
    component:GraphicDesigningPage
  },
  {
    path:'/photography',
    name:"PhotoGraphy",
    component:PhotoGraphyPage
  },
  // {
  //   path:'/3dmodeling',
  //   name:"ThreeDModeling",
  //   component:ThreeDmodelingPage
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
